import React, { useState, useEffect } from 'react';

import { Typography, Grid } from '@mui/material';

import { useStateValue } from '../../Contexto/store';

import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import PrivacyTipIcon from '@mui/icons-material/PrivacyTip';

/*import { styleToolBar, styleCameraButtons } from '../Tool/Style';*/

export const ListaPoliticasContrasena = ({ claveNueva, claveConfirma, PoliticasContrasenas }) => {

    const [{ etiquetasIdioma }, dispatch] = useStateValue();

    // Se declara la variable de estado que representa al idioma para las etiquetas del componente
    const [etiquetas, setEtiquetas] = useState({
        EtiquetasComponente: etiquetasIdioma ? etiquetasIdioma.EtiquetasComponente : DiccionarioEtiquetas.IdiomaDefault.Etiquetas,
        CodigoIdioma: etiquetasIdioma ? etiquetasIdioma.CodigoIdioma : DiccionarioEtiquetas.CodigoIdioma
    });

    useEffect(() => {
        // se llama al dispatch para que como tal se actualice el reducer
        setEtiquetas({
            EtiquetasComponente: etiquetasIdioma ? etiquetasIdioma.EtiquetasComponente : DiccionarioEtiquetas.IdiomaDefault.Etiquetas,
            CodigoIdioma: etiquetasIdioma ? etiquetasIdioma.CodigoIdioma : DiccionarioEtiquetas.CodigoIdioma
        });
    }, [etiquetasIdioma]);


    const [ValidaContrasena, setValidaContrasena] = useState({
        Minimo: false,
        Maximo: false,
        Numeros: false,
        Vocales: false,
        Mayuscula: false,
        Minuscula: false,
        CEspecial: false,
        Verificacion: false
    });

    

    useEffect(() => {       
        RealizaValidacionesPoliticas();
    }, []);

    useEffect(() => {       
        RealizaValidacionesPoliticas();
    }, [claveNueva]);

    useEffect(() => {
        RealizaValidacionesPoliticas();
    }, [claveConfirma]);


    const RealizaValidacionesPoliticas = () => {
        if (claveNueva.trim() === "" || claveConfirma.trim() === "")
            ActualizaValidacion("Verificacion", false);
        else if (claveNueva.trim() !== claveConfirma.trim())
            ActualizaValidacion("Verificacion", false);
        else
            ActualizaValidacion("Verificacion", true);

        //valida politicas
        //minimo caracteres
        if (PoliticasContrasenas.ppoMinimumCharacters == 0)
            ActualizaValidacion("Minimo", true);
        else if (PoliticasContrasenas.ppoMinimumCharacters > 0 && claveNueva.trim().length >= PoliticasContrasenas.ppoMinimumCharacters && claveNueva.trim() !== "")
            ActualizaValidacion("Minimo", true);
        else
            ActualizaValidacion("Minimo", false);

        //maximo caracteres
        if (PoliticasContrasenas.ppoMaximumCharacters == 0)
            ActualizaValidacion("Maximo", true);
        else if (PoliticasContrasenas.ppoMaximumCharacters > 0 && claveNueva.trim().length <= PoliticasContrasenas.ppoMaximumCharacters && claveNueva.trim() !== "")
            ActualizaValidacion("Maximo", true);
        else
            ActualizaValidacion("Maximo", false);

        //tiene numeros
        const TieneNumeros = /\d/;
        if (PoliticasContrasenas.ppoAllowsNumbers === false)
            ActualizaValidacion("Numeros", true);
        else if (PoliticasContrasenas.ppoAllowsNumbers && TieneNumeros.test(claveNueva) && claveNueva.trim() !== "")
            ActualizaValidacion("Numeros", true);
        else
            ActualizaValidacion("Numeros", false);

        //tiene vocales
        const TieneVocales = /[aeiou]/gi;
        if (PoliticasContrasenas.ppoAllowsVowels === false)
            ActualizaValidacion("Vocales", true);
        else if (PoliticasContrasenas.ppoAllowsVowels && TieneVocales.test(claveNueva) && claveNueva.trim() !== "")
            ActualizaValidacion("Vocales", true);
        else
            ActualizaValidacion("Vocales", false);

        //tiene mayuscula
        const TieneMayusculas = /[A-Z]/;
        if (PoliticasContrasenas.ppoCapitalLetter === false)
            ActualizaValidacion("Mayuscula", true);
        else if (PoliticasContrasenas.ppoCapitalLetter && TieneMayusculas.test(claveNueva) && claveNueva.trim() !== "")
            ActualizaValidacion("Mayuscula", true);
        else
            ActualizaValidacion("Mayuscula", false);

        //tiene minusculas
        const TieneMinusculas = /[a-z]/;
        if (PoliticasContrasenas.ppoLowercaseLetter === false)
            ActualizaValidacion("Minuscula", true);
        else if (PoliticasContrasenas.ppoLowercaseLetter && TieneMinusculas.test(claveNueva) && claveNueva.trim() !== "")
            ActualizaValidacion("Minuscula", true);
        else
            ActualizaValidacion("Minuscula", false);

        //tiene caracter especial
        const TieneCEspecial = /[!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?~]/;
        if (PoliticasContrasenas.ppoSpecialCharacter === false)
            ActualizaValidacion("CEspecial", true);
        else if (PoliticasContrasenas.ppoSpecialCharacter && TieneCEspecial.test(claveNueva) && claveNueva.trim() !== "")
            ActualizaValidacion("CEspecial", true);
        else
            ActualizaValidacion("CEspecial", false);


        //re-valida politicas
        //RealizaValidacionesPoliticas();
    };

    const ActualizaValidacion = (propiedad, estado) => {

        setValidaContrasena((prev) => ({
            ...prev,
            [propiedad]: estado
        }));

    };

    const ObtieneIconoValidacion = (politicaValidar) => {
        return ((politicaValidar) ?
            <CheckCircleOutlineIcon sx={{ fontSize: '18px', color: '#44d600' }} />
            :
            <CancelOutlinedIcon sx={{ fontSize: '18px', color: '#b00020' }} />
        );
    }

    const VerPorTrueFalse = (politicaVer) => {
        return (politicaVer) ? 'flex' : 'none';
    }

    const VerPorCantidad = (politicaVer) => {
        return (politicaVer > 0) ? 'flex' : 'none';
    }

    return (

        <Grid container style={{ padding: '0px', margin: '0px', with: '100%', backgroundColor: '#FFF' }}>
            <Grid item xs={12} sm={12} md={12} style={{ padding: '8px 12px', textAlign: 'center', }}>
                <Typography style={{ fontSize: '15px', fontWeight: '600', marginLeft: '5px' }}>{etiquetas.EtiquetasComponente.PoliticasContrasena.Et_PoliticasContrasena}</Typography>
            </Grid>

            <Grid item xs={12} sm={12} md={12} style={{ padding: '5px 12px', display: VerPorCantidad(PoliticasContrasenas.ppoMinimumCharacters) }}>
                {ObtieneIconoValidacion(ValidaContrasena.Minimo)}
                <Typography style={{ fontSize: '13px', marginLeft: '5px', marginTop: '-1px' }}>{etiquetas.EtiquetasComponente.PoliticasContrasena.Et_Minimo + PoliticasContrasenas.ppoMinimumCharacters + etiquetas.EtiquetasComponente.PoliticasContrasena.Et_Caracteres}</Typography>
            </Grid>

            <Grid item xs={12} sm={12} md={12} style={{ padding: '5px 12px', display: VerPorCantidad(PoliticasContrasenas.ppoMaximumCharacters) }}>
                {ObtieneIconoValidacion(ValidaContrasena.Maximo)}
                <Typography style={{ fontSize: '13px', marginLeft: '5px', marginTop: '-1px' }}>{etiquetas.EtiquetasComponente.PoliticasContrasena.Et_Maximo + PoliticasContrasenas.ppoMaximumCharacters + etiquetas.EtiquetasComponente.PoliticasContrasena.Et_Caracteres}</Typography>
            </Grid>

            <Grid item xs={12} sm={12} md={12} style={{ padding: '5px 12px', display: VerPorTrueFalse(PoliticasContrasenas.ppoAllowsNumbers) }}>
                {ObtieneIconoValidacion(ValidaContrasena.Numeros)}
                <Typography style={{ fontSize: '13px', marginLeft: '5px', marginTop: '-1px' }}>{etiquetas.EtiquetasComponente.PoliticasContrasena.Et_Numeros}</Typography>
            </Grid>

            <Grid item xs={12} sm={12} md={12} style={{ padding: '5px 12px', display: VerPorTrueFalse(PoliticasContrasenas.ppoAllowsVowels) }}>
                {ObtieneIconoValidacion(ValidaContrasena.Vocales)}
                <Typography style={{ fontSize: '13px', marginLeft: '5px', marginTop: '-1px' }}>{etiquetas.EtiquetasComponente.PoliticasContrasena.Et_Vocales}</Typography>
            </Grid>

            <Grid item xs={12} sm={12} md={12} style={{ padding: '5px 12px', display: VerPorTrueFalse(PoliticasContrasenas.ppoCapitalLetter) }}>
                {ObtieneIconoValidacion(ValidaContrasena.Mayuscula)}
                <Typography style={{ fontSize: '13px', marginLeft: '5px', marginTop: '-1px' }}>{etiquetas.EtiquetasComponente.PoliticasContrasena.Et_Mayuscula}</Typography>
            </Grid>

            <Grid item xs={12} sm={12} md={12} style={{ padding: '5px 12px', display: VerPorTrueFalse(PoliticasContrasenas.ppoLowercaseLetter) }}>
                {ObtieneIconoValidacion(ValidaContrasena.Minuscula)}
                <Typography style={{ fontSize: '13px', marginLeft: '5px', marginTop: '-1px' }}>{etiquetas.EtiquetasComponente.PoliticasContrasena.Et_Minuscula}</Typography>
            </Grid>

            <Grid item xs={12} sm={12} md={12} style={{ padding: '5px 12px', display: VerPorTrueFalse(PoliticasContrasenas.ppoSpecialCharacter) }}>
                {ObtieneIconoValidacion(ValidaContrasena.CEspecial)}
                <Typography style={{ fontSize: '13px', marginLeft: '5px', marginTop: '-1px' }}>{etiquetas.EtiquetasComponente.PoliticasContrasena.Et_CEspecial}</Typography>
            </Grid>

            <Grid item xs={12} sm={12} md={12} style={{ padding: '5px 12px', display: 'flex' }}>
                {ObtieneIconoValidacion(ValidaContrasena.Verificacion)}
                <Typography style={{ fontSize: '13px', marginLeft: '5px', marginTop: '-1px' }}>{etiquetas.EtiquetasComponente.PoliticasContrasena.Et_Confirmacion}</Typography>
            </Grid>

            <Grid item xs={12} sm={12} md={12} style={{ padding: '5px 12px 8px 12px', display: VerPorCantidad(PoliticasContrasenas.ppoPasswordHistory) }}>
                <PrivacyTipIcon sx={{ fontSize: '18px' }} />
                <Typography style={{ fontSize: '13px', marginLeft: '5px', marginTop: '-1px' }}>{etiquetas.EtiquetasComponente.PoliticasContrasena.Et_Historico + PoliticasContrasenas.ppoPasswordHistory}</Typography>
            </Grid>
        </Grid>

        
    );
}
